<script setup lang="ts">
import dayjs from 'dayjs';
import { storeToRefs } from 'pinia';
import { useStore } from 'vuex';

import { useCart } from '@/composables/useCart';
import { useCustomer } from '@/stores/customer';

const store = useStore();
const { cartCopiedFromOrder, customerEmail } = useCart(store);
const { customer, signedUpAt } = storeToRefs(useCustomer());
</script>

<template>
  <div>
    <div class="flex items-center justify-between mb-4">
      <div class="flex items-center">
        <div class="text-lg font-semibold md:text-xl">Email</div>
        <div class="ml-1 text-sm md:text-base text-neutral-500">(Optional)</div>
      </div>
      <RouterLink
        v-if="!cartCopiedFromOrder"
        to="/checkout/signin"
        class="text-xs underline color-inherit"
      >
        Change
      </RouterLink>
    </div>
    <template v-if="customerEmail">
      <div class="mb-4 text-sm md:text-base">{{ customerEmail }}</div>
      <div v-if="customer" class="text-sm md:text-base">
        <div class="font-semibold">Order linked to account:</div>
        <div v-if="customer.lastName">{{ customer.lastName }}</div>
        <div v-else>Customer name not available</div>
        <div>Member since: {{ dayjs(signedUpAt).format('MMM D, YYYY') }}</div>
      </div>
      <div v-else class="text-sm md:text-base">
        <div class="font-semibold">No account found</div>
        <div>Order history won't be linked to an account</div>
      </div>
    </template>
    <div v-else class="text-sm md:text-base">No email was entered</div>
  </div>
</template>
